<template>
    <div class="color-picker-item" @click="(e) => showPicker(e)" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
        <label for="representativeBubbleColor">{{ title }}</label>
        <round-slider
            :value="getOpacityValueFromHex()"
            start-angle="0"
            end-angle="+360"
            line-cap="round"
            radius="60"
            :min="0"
            :max="100"
            :update="(value) => setOpacity(value)"
            :rangeColor="rawColor"
            :read-only="!opacitySlider"
            :step="5"
            :width="10"
            circleShape="half-top"
            lineCap="butt"
            borderColor="var(--color-border-default)"
            :editableTooltip="false"
            class="theme-color-slider"
        />

        <div class="color-palette-circle" @click="(e) => showPicker(e)" :style="{ 'background-color': rawColor }"></div>
        <a-input
            v-model="color"
            class="theme-color-input v-hidden"
            type="color"
            ref="colorRef"
            @click="(e) => showPicker(e, true)"
        />
        <!--        <a-slider-->
        <!--            :class="{ hidden: !opacitySlider }"-->
        <!--            :max="100"-->
        <!--            :min="0"-->
        <!--            :step="5"-->
        <!--            :value="getOpacityValueFromHex()"-->
        <!--            @change="(value) => setOpacity(value)"-->
        <!--        />-->
    </div>
</template>

<script>
import _ from "lodash";
import { COLOR_ALPHA_MAP, COLOR_ALPHA_MAP_REVERSE } from "../../../../../utils/colorUtils";
import RoundSlider from "vue-round-slider";
import log2 from "../../../../../utils/log2";

const log = log2("ColorPickerItem");
export default {
    name: "ColorPickerItem",
    components: {
        RoundSlider,
    },
    props: {
        title: String,
        value: String,
        rawColor: String,
        opacitySlider: {
            type: Boolean,
            default: false,
        },
        onMouseEnter: {
            type: Function,
            default: () => {},
        },
        onMouseLeave: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            color: _.cloneDeep(this.value),
            alphaMap: COLOR_ALPHA_MAP,
            alphaMapRev: COLOR_ALPHA_MAP_REVERSE,
        };
    },
    methods: {
        showPicker(e, self) {
            log("showPicker", e);
            e.stopPropagation();
            if (self) return;
            e.preventDefault();
            this.$refs.colorRef.$el.click();
        },
        getOpacityValueFromHex() {
            const hex = this.rawColor.substring(1).split("");
            log("getOpacityValueFromHex", hex, this.rawColor);
            if (hex.length === 8) {
                const opacity = hex.pop();
                const opacity2 = hex.pop();
                log("getOpacityValueFromHex", opacity, opacity2, this.alphaMapRev[opacity + opacity2]);
                return this.alphaMapRev[opacity + opacity2];
            }
            return 100;
        },
        setOpacity(event) {
            const value = Math.max(0, event.value % 5 === 0 ? event.value : event.value - (event.value % 5));
            log("setOpacity", value, event.value);
            const old = this.color;
            let hex = this.color.substring(1).split("");
            if (hex.length === 8) {
                hex.pop();
                hex.pop();
            }
            hex = "#" + hex.join("");
            const result = hex + this.alphaMap[value];
            log("setOpacity", { old, hex, result, value });
            this.color = result;
        },
        addAlpha(hex, e) {
            const old = hex;

            hex = hex.substring(1).split("");
            if (hex.length === 8) {
                hex.pop();
                hex.pop();
            }
            hex = "#" + hex.join("");
            const result = hex + this.alphaMap[e];
            log("addAlpha", { old, hex, result });
            return hex + this.alphaMap[e];
        },
    },
    watch: {
        color(val) {
            this.$emit("input", val);
        },
    },
};
</script>

<style scoped lang="scss">
.color-picker-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    background: var(--color-bg-default);
    padding: 10px;
    border: 1px solid var(--color-border-default);
    border-radius: 4px;
    min-width: 200px;
    position: relative;
    cursor: pointer;

    &:hover {
        border: 1px solid var(--color-border-hover);
        box-shadow: 0 0 0 1px var(--color-border-hover);
    }

    .color-palette-circle {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 1px solid var(--color-border-default);
        cursor: pointer;
        position: absolute;
        top: 65px;
        z-index: 1;

        &:hover {
            border: 1px solid var(--color-border-hover);
            box-shadow: 0 0 0 1px var(--color-border-hover);
        }
    }

    .ant-slider {
        width: 100%;
    }

    .v-hidden,
    .hidden {
        visibility: hidden;
    }
}
</style>
<style lang="scss">
.theme-color-slider {
    .rs-tooltip,
    .rs-edit {
        display: none !important;
        z-index: -1 !important;
    }
}
</style>
